// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__Bw0O1","btns":"footer_btns__fFQ6C"};